<script>
    import DateSearcher from "./DateSearcher.svelte";
    import { onMount } from "svelte";
    import Searchbar from "./SearchBar.svelte";
    import { mpTableFilter } from "../../stores/membershipPrintTableFilterStore";
    import { settings } from "../../stores/settingsStore";

    let referenceYears = [];

    function generateRefYears () {
        const minYear = 2017;

        referenceYears = Array(Math.max(new Date().getFullYear(), $settings.subscriptionActiveYear) - 2017 + 1)
            .fill(null)
            .map((_, i) => minYear + i);
    }

    function updateFilters(key, newValue) {
        $mpTableFilter = { ...($mpTableFilter ?? {}), page: 1, [key]: newValue };
    }

    onMount(() => {
        generateRefYears();
    });
</script>

<div class="w-full flex flex-col gap-1 relative">
    <div class="flex justify-between items-center">
        <div class="text-gray-500">
            Filtra per
        </div>

    </div>

    <div class="flex flex-col items-center gap-1 w-full lg:flex-row">
        <div class="lg:w-6/12 w-full">
            <Searchbar
                placeholder="Filtra per codice della stampa"
                hasLabel={false}
                value={$mpTableFilter.code}
                on:search={(e) => updateFilters("code", e.detail) }
            />
        </div>

        <div class="lg:w-6/12 w-full">
            <select
                value={+$mpTableFilter.year}
                on:change={(e) => updateFilters("year", +e.target.value)}
                class="w-full input-home no-shadow outline-none h-11 focus:outline-none"
            >
                {#each referenceYears as year}
                    <option value={year}>{year}</option>
                {/each}
            </select>
        </div>

    </div>

    <div class="flex flex-col md:flex-row gap-1 md:h-11">
        <DateSearcher
            containerClass="no-shadow"
            placeholder="Dal"
            bind:value={$mpTableFilter.from}
        />

        <DateSearcher
            containerClass="no-shadow"
            placeholder="Al"
            bind:value={$mpTableFilter.to}
        />
    </div>

    <Searchbar
        placeholder="Filtra per note"
        hasLabel={false}
        value={$mpTableFilter.notes}
        on:search={(e) => updateFilters("notes", e.detail) }
    />
</div>